/* eslint-disable*/
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRefresh,
  faDownload,
  faHome,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { API_URL } from "../../config"; // Adjust path as needed
import LoadingSpinner from "../../components/LoadingSpinner.jsx"; // Adjust path as needed
import moment from "moment";

const TwitterDailyPost = () => {
  const [loading, setLoading] = useState(false);
  const [twitterPosts, setTwitterPosts] = useState([]);
  const [modalImage, setModalImage] = useState("");
  const [showModal, setShowModal] = useState(false);

  // Fetch Twitter posts data
  const fetchTwitterPosts = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");

      const response = await axios.get(`${API_URL}lead-source-cost/latest`, {
        headers: {
          Authorization: `Bearer ${token}`,
          accept: "application/json",
        },
      });

      if (response.data) {
        setTwitterPosts(response.data);
      }
    } catch (error) {
      console.error("Error fetching Twitter posts:", error);
      setTwitterPosts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTwitterPosts();
  }, []);

  // Get latest posts from external API
  const getLatestPosts = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        "https://streetapp.streetgains.in/apis/twitterDailyPost"
      );

      if (response.data.status === "success") {
        alert("Success! Image Process Initiated");
        // Refresh the posts after successful API call
        fetchTwitterPosts();
      } else {
        alert("Error! An error occurred. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching latest posts:", error);
      alert("Error! There was a problem contacting the server.");
    } finally {
      setLoading(false);
    }
  };

  // Handle image click to show modal
  const handleImageClick = (imageUrl) => {
    setModalImage(imageUrl);
    setShowModal(true);
  };

  // Close modal
  const closeModal = () => {
    setShowModal(false);
    setModalImage("");
  };

  // Handle modal background click
  const handleModalClick = (e) => {
    if (e.target.id === "imageModal") {
      closeModal();
    }
  };

  return (
    <div className="page-header-fixed page-sidebar-fixed fade in">
      {/* {loading && <LoadingSpinner />} */}

      {/* Image Modal */}
      {showModal && (
        <div
          id="imageModal"
          onClick={handleModalClick}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            cursor: "pointer",
          }}
        >
          <div
            id="modalContent"
            style={{
              position: "relative",
              padding: "10px",
              textAlign: "center",
              display: "block",
              maxWidth: "90%",
              maxHeight: "90vh",
              borderRadius: "8px",
              alignItems: "center",
              marginTop: "10rem",
            }}
          >
            <span
              id="closeModal"
              onClick={closeModal}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                fontSize: "30px",
                fontWeight: "bold",
                color: "white",
                cursor: "pointer",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                borderRadius: "50%",
                padding: "5px",
                zIndex: 1001,
              }}
            >
              ×
            </span>
            <img
              id="modalImage"
              src={modalImage}
              alt="Enlarged view"
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "80vh",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      )}

      {/* Breadcrumb */}
      <div className="row pb-2">
        <div className="col-md-3">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/dashboard" style={{ textDecoration: "none" }}>
                <FontAwesomeIcon icon={faHome} /> Home
              </a>
            </li>
            <li className="breadcrumb-item active">Twitter Daily Post</li>
          </ul>
        </div>
      </div>

      {/* Main Panel */}
      <div className="panel panel-default with-rounded-corner with-shadow">
        <div className="panel-heading">
          <h4 className="panel-title pull-left">Twitter Daily Post</h4>
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-default btn-sm"
              id="getPostData"
              onClick={getLatestPosts}
              disabled={loading}
            >
              <FontAwesomeIcon icon={faRefresh} /> Get Latest Post
            </button>
          </div>
        </div>

        <div className="panel-body">
          {twitterPosts.length > 0 ? (
            <div className="table-responsive">
              <table className="table m-b-0">
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}>#</th>
                    <th>Date</th>
                    <th>Media</th>
                    <th>Download</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    Array.from({ length: 8 }).map((_, rowIndex) => (
                      <tr key={rowIndex} className="skeleton-row">
                        {Array.from({ length: 4 }).map((_, colIndex) => (
                          <td key={colIndex}>
                            <div className="skeleton-box"></div>
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : twitterPosts.length > 0 ? (
                    twitterPosts.map((post, index) => (
                      <tr key={post.id}>
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                          {index + 1}
                        </td>
                        <td style={{ verticalAlign: "middle" }}>
                          {moment(post.created_on).format("DD MMM YYYY")}
                        </td>
                        <td style={{ verticalAlign: "middle" }}>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleImageClick(`${API_URL}${post.media_url}`);
                            }}
                            style={{ textDecoration: "none" }}
                          >
                            <img
                              src={`${API_URL}${post.media_url}`}
                              alt="Post"
                              style={{
                                maxWidth: "100px",
                                cursor: "pointer",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                              }}
                            />
                          </a>
                        </td>
                        <td style={{ verticalAlign: "middle" }}>
                          <a
                            href={`${API_URL}${post.media_url}`}
                            className="btn btn-sm btn-primary"
                            download
                          >
                            <FontAwesomeIcon icon={faDownload} /> Download Image
                          </a>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center p-4">
                        No Twitter posts found.
                      </td>
                    </tr>
                  )}
                </tbody>

              </table>
            </div>
          ) : (
            <div className="text-center p-4">
              <p>No Twitter posts found.</p>
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        .breadcrumb {
          background: transparent;
          margin-bottom: 0;
          padding: 0;
          list-style: none;
          display: flex;
          align-items: center;
        }

        .breadcrumb-item {
          display: flex;
          align-items: center;
        }

        .breadcrumb-item + .breadcrumb-item::before {
          content: ">";
          padding: 0 8px;
          color: #6c757d;
        }

        .breadcrumb-item a {
          color: #007bff;
          text-decoration: none;
        }

        .breadcrumb-item.active {
          color: #6c757d;
        }

        .panel {
          background: white;
          border-radius: 4px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          margin-bottom: 20px;
        }

        .panel-heading {
          padding: 15px;
          border-bottom: 1px solid #eee;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .panel-title {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
        }

        .pull-left {
          float: left;
        }

        .panel-body {
          padding: 15px;
        }

        .with-rounded-corner {
          border-radius: 4px;
        }

        .with-shadow {
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        .table {
          width: 100%;
          margin-bottom: 1rem;
          background-color: transparent;
          border-collapse: collapse;
        }

        .table th,
        .table td {
          padding: 0.75rem;
          vertical-align: top;
          border-top: 1px solid #dee2e6;
        }

        .table thead th {
          vertical-align: bottom;
          border-bottom: 2px solid #dee2e6;
          font-weight: 600;
        }

        .m-b-0 {
          margin-bottom: 0;
        }

        .btn {
          display: inline-block;
          font-weight: 400;
          text-align: center;
          white-space: nowrap;
          vertical-align: middle;
          user-select: none;
          border: 1px solid transparent;
          padding: 0.375rem 0.75rem;
          font-size: 0.875rem;
          line-height: 1.5;
          border-radius: 0.25rem;
          transition: all 0.15s ease-in-out;
        }

        .btn-default {
          color: #333;
          background-color: #fff;
          border-color: #ccc;
        }

        .btn-default:hover {
          color: #333;
          background-color: #e6e6e6;
          border-color: #adadad;
        }

        .btn-default:disabled {
          opacity: 0.65;
          cursor: not-allowed;
        }

        .btn-sm {
          padding: 0.25rem 0.5rem;
          font-size: 0.875rem;
          line-height: 1.5;
          border-radius: 0.2rem;
        }

        .btn-primary {
          color: #fff;
          background-color: #007bff;
          border-color: #007bff;
        }

        .btn-primary:hover {
          color: #fff;
          background-color: #0069d9;
          border-color: #0062cc;
        }

        .table-responsive {
          display: block;
          width: 100%;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }

        .text-center {
          text-align: center;
        }

        .p-4 {
          padding: 1.5rem;
        }
      `}</style>
    </div>
  );
};

export default TwitterDailyPost;